import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './card-tag.scss.js';

class CardTag extends s {
    constructor() {
        super(...arguments);
        this.additionalClasses = '';
        this.tagTitle = '';
    }
    render() {
        return x `<div class="tag inactive ${this.additionalClasses}"><span class="tagName"><slot></slot></span></div>`;
    }
}
CardTag.styles = css_248z;
__decorate([
    n({ type: String })
], CardTag.prototype, "additionalClasses", void 0);
__decorate([
    n({ type: String })
], CardTag.prototype, "tagTitle", void 0);
customElements.define('card-tag', CardTag);

export { CardTag };
